import angular from 'angular';
import APIV5 from '~/models/api';
import Repre from '~/scripts/services/model/repre';
import AdminWfDesignerService from '~/scripts/services/model/admin-wf-designer.service';
import { ConfirmDeleteModal } from '~/utils/modals';
import AdminWfController from '~/pages/admin/wf/admin-wf.controller';
import templateModalWfRole from '../modal/modal-wf-role.html';
import ModalWfRoleController from '../modal/modal-wf-role.controller';

export default class WfEditorHomeController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {any} User
	 */
	constructor(
		$injector,
		$location,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		NodeService,
		Notification,
		User,
	) {
		this.$injector = $injector;
		this.$location = $location;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		/** @type {?AdminWfController} */
		this.adminWf = null;

		/** @type {any[]} */
		this.prodWorkflows = [];

		/** @type {any[]} */
		this.roles = [];

		/** @type {any[]} */
		this.savedWorkflows = [];

		/** @type {any} */
		this.wfTmp = undefined;
	}

	$onInit() {
		(async () => this.listWorkflows())();
		this.$scope.$on('admin-wf-load-roles', () => this.loadRoles());
		this.$scope.$on('admin-wf-list-schemas', () => this.listWorkflows());
		(async () => this.loadRoles())();
	}

	async addRole() {
		const role = this.NodeService.create('K_NODE;WF_ROLE', `K_NODE;${this.User.getRefNr()}`);
		const repre = new Repre();
		repre.type = 'K_NODE;STRING';
		role.addRepre(repre);

		const object = await this.$uibModal.open({
			template:     templateModalWfRole,
			controller:   ModalWfRoleController,
			controllerAs: '$ctrl',
			resolve:      {
				role:   () => role,
				edit:   () => true,
				create: () => true,
			},
		}).result;

		if (object.type === 'ADD') {
			// eslint-disable-next-line promise/no-nesting
			await this.NodeService.update(object.role);
			this.Notification.success({
				title:   this.$translate.instant('object.successfully-created-title'),
				message: this.$translate.instant('object.successfully-created-message'),
			});
			await this.loadRoles();
		}
	}

	/**
	 * @param {Event} event
	 * @param {any} role
	 */
	async confirmDeleteRole(event, role) {
		event.preventDefault();

		const modal = new ConfirmDeleteModal(this.$injector);
		const answer = await modal.open(role.name);

		if (answer) {
			APIV5.instance.objectDelete({ items: role.kid }, { id: 'wf-editor-home.confirm-delete-role' })
				.then(() => this.loadRoles())
				.catch(() => {
					// @ts-ignore
					angular.element(event.target).closest('.list-group-item').trigger('blur');
				});
		}
	}

	/**
	 * @param {Event} event
	 * @param {any} workflow
	 */
	async deleteWorkflow(event, workflow) {
		event.preventDefault();

		try {
			await this.adminWf?.confirmDeleteWorkflow(workflow);
			await this.listWorkflows();
		}
		catch (error) {
			console.error(error);
			// @ts-ignore
			angular.element(event.target).closest('.list-group-item').trigger('blur');
		}
	}

	/**
	 * @param {Event} event
	 * @param {any} workflow
	 */
	async duplicateWorkflow(event, workflow) {
		const newTab = new AdminWfDesignerService(this.$injector);
		const tab = await newTab.load(workflow.kid, true, true);
		// @ts-ignore
		this.adminWf?.tabs.push(tab);
		this.$timeout(() => {
			if (tab) {
				tab.schema.roles = this.roles;
			}
			this.$scope.$apply();
		});
	}

	/**
	 * @param {any} role
	 * @returns {any}
	 */
	editRole(role) {
		return this.$location.url(`/form/${role.kid}?from=admin/wf`);
	}

	async loadRoles() {
		const roles = await this.NodeService.list('K_NODE;WF_ROLE');
		if (roles) {
			this.roles = roles.map((/** @type {import('~/scripts/services/model/node').default} */ r) => ({
				kid:  r.kid,
				name: r.getName(),
			}));
		}
		else {
			this.roles.length = 0;
		}
	}

	async listWorkflows() {
		/** @type {any} */
		const savedWorkflows = await APIV5.instance.mfSuggestion2(
			'K_NODE;WF_DESIGNER_SCHEMA',
			null,
			{
				id: 'wf-editor-home.list-workflows',
				nocache: true,
			},
		);
		this.savedWorkflows = savedWorkflows.result;

		/** @type {any} */
		const productionWorkflows = await APIV5.instance.wfWorkflowList(
			{ id: 'wf-editor-home.list-workflows' },
		);
		this.prodWorkflows = productionWorkflows.wfworkflowlist;

		this.$timeout(() => {
			this.$scope.$apply();
		});
	}

	newWF() {
		this.adminWf?.newWF();
	}

	// eslint-disable-next-line class-methods-use-this
	openSchemaFromFile() {
		angular.element('#input-wf-file-hidden').find('input[type="file"]').trigger('click');
	}
}
